module.exports = __webpack_public_path__ + "img/jindo-logotype-stacked.86d8a751.svg";